import { FC, SVGProps } from "react";

export const FibonacciIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 16,
  height = 16,
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 224.6 174"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
      }}
      {...props}
    >
      <path
        d="M81.1 159.5v-15.4h143.4v15.4H81.1zm61.5-128.8H.3V15.2h142.3v15.5zm55.5-7.7c.5 11.4-8.7 22.4-22.6 22.8-12.1.3-22.7-10.8-22.6-23.1.1-12.2 10.9-23 22.8-22.7 12.7.3 22.4 10.3 22.4 23zM48.5 128.7c12.8.1 22.6 9.9 22.5 22.7 0 12.7-10 22.6-22.8 22.6-12.5-.1-22.4-10.4-22.3-23.2 0-12.3 10-22.2 22.6-22.1zm102.6-48.8c26.6-.1 45.7 0 72.3 0h1.2v15.5h-90.5c9-8.4 17-15.5 17-15.5zm-151 16V80.2h89.4c-5.5 5.4-8.6 8.5-15.9 15.7H.1zm126.2-12.1c-6 6-11.8 11.7-18.4 18.3-3.6-3.6-7.2-7.3-10.8-11.1 5.9-5.6 12.1-12 18.4-18 2.9 3 7.2 7.2 10.8 10.8zm29.3-29.3l-17.3 17.3c-3.7-3.7-7.3-7.4-11-11.1 5.7-5.6 11.6-11.4 17.6-17.2 3.2 3.3 6.9 7.1 10.7 11zm-59.4 59.4c-5.3 5.3-11.2 11.1-17.6 17.3-3.5-3.8-7.1-7.6-10.7-11.6 6-5.8 11.8-11.5 17.6-17.2 3.4 3.7 7 7.6 10.7 11.5zm128.3-83.1h-16.2V15.2h16.2v15.6zM0 159.6v-15.3h15.6v15.3H0z"
        fill={fill}
      ></path>
    </svg>
  );
};
